import { render, staticRenderFns } from "./CompanyCustomerSupportThreads.vue?vue&type=template&id=2c3a5e94&"
import script from "./CompanyCustomerSupportThreads.vue?vue&type=script&lang=js&"
export * from "./CompanyCustomerSupportThreads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports